import React, { Component } from 'react';
import { ApiClient } from "../../libs/apiClient";
import { SERVICE_RESPONSE } from '../../libs/utils/Const';
import download from 'js-file-download';
import $ from 'jquery';
import moment from 'moment';
import { DateTime } from 'luxon';

import StandardSelectModal from "../StandardSelectModal";
const apiClient = ApiClient.getInstance();
const itemsHeaders = [
    { title: "Nombre", value: true, filter: true, field: "RecepNombre", format: null, classes: "text-left" },
    { title: "RFC", value: true, filter: true, field: "RecepRfc", format: null, classes: "text-left" },
    { title: "CURP", value: true, filter: true, field: "NomRecepCurp", format: null, classes: "text-left" },
];

class NominaModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            UnidadConcepts: [],
            NomEmployees: [],
            searchItem: "",
            enableSelectEmployee: false,
        };
    }

    componentDidMount = async () => {
        this.CallNominaInfoCatalogs()

    }

    CloseModal = () => {
        const { model } = this.props;

        this.restartTabs();
    }

    ChangeModelPropByKey = (key, event) => {
        const { model, refreshModel } = this.props;
        let copyModel = Object.assign({}, model);
        copyModel[key] = event.target.value
        refreshModel(copyModel);
    }

    ChangeModelPropSubLevelByKey = async (key, subKey, value) => {
        const { model, refreshModel } = this.props;
        // const value = event.target.value;

        let copyModel = { ...model };

        // Inicializa el objeto si no existe
        if (!copyModel[key]) {
            copyModel[key] = {};
        }

        copyModel[key][subKey] = value;

        await refreshModel(copyModel);
        this.ChangePropByModifiedData(key, subKey, value)
    };

    ChangePropByModifiedData = async (key, subKey, value) => {
        const { model, refreshModel } = this.props;
        let copyModel = Object.assign({}, model);

        if (key === 'nomina' && (subKey === 'fechaInicialPago' || subKey === 'fechaFinalPago')) {
            copyModel.nomina.numDiasPagados = this.diasEntreFechas(copyModel.nomina.fechaInicialPago, copyModel.nomina.fechaFinalPago);
            copyModel.nomina.receptor.antiguedad = this.calcularAntiguedadCalendario(model.nomina?.receptor?.fechaInicioRelLaboral, copyModel.nomina.fechaFinalPago)
        }

        await refreshModel(copyModel);
    }

    calcularAntiguedadCalendario(fechaInicioStr, fechaFinStr) {
        const inicio = DateTime.fromISO(fechaInicioStr);
        const fin = DateTime.fromISO(fechaFinStr);

        if (inicio > fin) return "ERROR: FechaInicioRelLaboral es mayor que FechaFinalPago";

        const diff = fin.diff(inicio, ['years', 'months', 'days']).toObject();

        const años = Math.floor(diff.years || 0);
        const meses = Math.floor(diff.months || 0);
        const dias = Math.floor(diff.days || 0);

        let resultado = 'P';
        if (años > 0) resultado += `${años}Y`;
        if (meses > 0) resultado += `${meses}M`;
        if (dias > 0 || resultado === 'P') resultado += `${dias}D`; // siempre debe llevar al menos D
   
        return resultado;
    }

    diasEntreFechas = (fechaInicio, fechaFin) => {
        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);

        if (inicio > fin) return 0;

        const diferenciaMs = fin - inicio;
        const diferenciaDias = Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24)) + 1;

        return diferenciaDias;
    }


    ChangeModelPropNominaSubLevelByKey = (key, subKey, event) => {
        const { model, refreshModel } = this.props;
        let copyModel = Object.assign({}, model);
        copyModel.nomina[key][subKey] = event.target.value
        refreshModel(copyModel);
    }

    ValidateNominaModel = () => {
        const { model, showAlert } = this.props
        // let flag = true;
        if (false) {
            showAlert({ type: 'info', message: `Favor de llenar el campo `, timeOut: 5000 });

        }

        return true;
    }


    sendModel = () => {
        if (this.ValidateNominaModel()) {
            this.props.sendModel()
        }
    }

    CloseModal = () => {
        this.props.closeModalActions()
    }

    //#region CATÁLOGOS SAT

    CallNominaInfoCatalogs = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);
        const infoPorteCatalogsResponse = await apiClient.GetNominaInfoCatalogs();
        enableSpinner(false);
        // const filterUnidadConcepts = infoPorteCatalogsResponse?.data?.unidadPeso.filter((element) => Number(element.Simbolo) === 1);

        if (infoPorteCatalogsResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                unidadPeso: infoPorteCatalogsResponse.data.unidadPeso,
                UnidadConcepts: infoPorteCatalogsResponse.data?.unidadPesoConcepts ?? [],
            });
        }
    };
    //#endregion

    ChangeConceptProp = (index, key, event) => {

        const { model, refreshModel } = this.props;
        let copyModel = Object.assign({}, model);
        copyModel.conceptos[index][key] = event.target.value
        refreshModel(copyModel);

        if (key === 'descuento' || key === 'valorUnitario') {
            this.RefreshTotalsProps()
        }
    }


    RefreshTotalsProps = () => {
        const { model, refreshModel } = this.props;
        let copyModel = Object.assign({}, model);
        // copyModel.conceptos[index][key] = event.target.value;
        copyModel.subTotal = model.conceptos.reduce((total, objeto) => total + Number(objeto.valorUnitario), 0);
        copyModel.descuento = model.conceptos.reduce((total, objeto) => total + Number(objeto.descuento), 0);
        copyModel.total = copyModel.subTotal - copyModel.descuento;

        refreshModel(copyModel);
    }

    DownloadDocNomina = async (type) => {
        const { model, showAlert, enableSpinner } = this.props;
        // pdf.create(contenido, options).toFile(rutaPDf + 'Nom' + "_" + headerDocument.IdNom + "_" + headerDocument.RecepNombre + "_" + headerDocument.NomFechaPago + "_" + dataXML.datosXML.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID + ".pdf", function (err: any, res: any) {
        const fileExt = type === 'PDF' ? '.pdf' : '.xml'
        const data = {
            type,
            nominaFile: "Nom" + "_" + model.IdNom + "_" + model.receptor.nombre + "_" + model.nomina.fechaPago + "_" + model.UUID + fileExt
        }
        enableSpinner(true);
        const responsePdf = await apiClient.DownloadNominaDocs(data);
        enableSpinner(false);

        let getFieldName = responsePdf.headers.get('content-disposition');
        if (getFieldName !== null) {
            // Get File Name from HTTP header
            let start = getFieldName.indexOf("filename=") + 10;
            let end = getFieldName.indexOf('"', start);
            try {
                responsePdf.blob().then(blob => download(blob, getFieldName.slice(start, end)));
            } catch (e) {
                showAlert({ type: 'error', message: `Error al traer el ${type} de CARTA PORTE`, timeOut: 5000 });
            }
        }
        else {
            showAlert({ type: 'error', message: 'No se encontró el archivo en su ruta', timeOut: 5000 });
        }
    }

    render() {
        const { action, model, acceptDeleteModel } = this.props;
        const { editMode, } = this.state;

        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="TimbradoNominasModal"
                role="dialog"
                aria- labelledby="exampleModalCenterTitle"
                aria-hidden="true" >

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">REGISTRO DE NOMINA</h4>
                            <button type="button" className="close" onClick={this.CloseModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.renderEditButton()}
                                                {this.renderHeaderFields()}
                                                {this.renderNominaBody()}
                                                {this.renderNominaFooter()}
                                                <br></br><br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">

                            {/* {action != 1 && !editMode && view !== 'consignmentNote' && (
                                <button type="button" className="btn botonCerrar text-white" style={{ background: '#c42222 !important' }} onClick={this.deleteModel}>
                                    Eliminar
                                </button>
                            )} */}

                            <button type="button" className="btn botonCerrar text-white" onClick={this.CloseModal}>Cerrar
                            </button>
                            {action === 1 && <button type="button" className="btn botonCorrect text-black"
                                onClick={this.sendModel}> Crear</button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn btn-danger text-white" onClick={() => this.openCloseAgreeModal(true)}>
                                    Eliminar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}

                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>


            </div >
        );
    }

    //#region render visual
    renderEditButton = () => {
        const { action, view } = this.props;
        const { editMode } = this.state;
        if (action === 2 && !editMode) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    renderInput = (label, value, onChange, disabled, type = "text") => (
        <div className="input-group mb-3">
            <div className="input-group-prepend">
                <span className="input-group-text font-weight-bold">{label}</span>
            </div>
            <input type={type} className="form-control" value={value || ""} onChange={onChange} disabled={disabled} />
        </div>
    );

    renderSelect = (label, value, options, onChange, disabled) => (
        <div className="input-group mb-3">
            <div className="input-group-prepend">
                <span className="input-group-text font-weight-bold">{label}</span>
            </div>
            <select className="form-control" value={value || ""} onChange={onChange} disabled={disabled}>
                {options && options.map((opt, idx) => (
                    <option key={idx} value={opt.value}>{opt.label}</option>
                ))}
            </select>
        </div>
    );

    OpenNomEmployeeList = async () => {
        const { model, view, enableSpinner, showAlert } = this.props;
        const TODAY = moment(new Date()).format('YYYY-MM-DD');

        const data = {
            dateInit: TODAY,
            dateFinal: TODAY,
            keySearch: model.receptor?.nombre ?? '--',
        };

        enableSpinner(true);
        const resData = await apiClient.GetListEmployeeNom(data);
        enableSpinner(false);

        if (resData.status !== 1) {
            showAlert({ type: 'warning', timeOut: 5000, message: `${resData.message ?? ''}` });
            return
        }

        if (resData.data.length === 0) {
            showAlert({ type: 'info', timeOut: 5000, message: `No se encontró información` });
        }

        await this.setState({
            enableSelectEmployee: true,
            NomEmployees: resData.data ?? []
        })
        // $("#selectItemsModal").on("hidden.bs.modal", async () => { await this.setState({ showItemsModal: false }); });
        $("#selectEmployeeModal").modal("show");
    };

    SelectEmployee = async (selectedEmployee) => {
        const { enableSpinner, showAlert } = this.props;
        const data = {
            primaryKey: selectedEmployee.IdNomEmployee,
        }

        enableSpinner(true);
        const responseApi = await apiClient.ReadEmployeeNom(data);
        enableSpinner(false);

        $("#selectEmployeeModal").modal("hide");

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? 'Error inesperado al obtener la info del empleado' });
            return
        }

        await this.FillNominaModelWithEmployeeData(responseApi.data.employee)


    }

    FillNominaModelWithEmployeeData = (infoEmployee) => {
        const { model, refreshModel } = this.props;
        let auxCopy = Object.assign(model, {});
        auxCopy.receptor.nombre = infoEmployee?.RecepNombre ?? '';
        auxCopy.receptor.rfc = infoEmployee?.RecepRfc ?? '';
        auxCopy.receptor.usoCFDI = infoEmployee?.RecepUsoCfdi ?? '';
        auxCopy.receptor.regimenFiscalReceptor = infoEmployee?.RecepRegimenFiscal ?? '';
        auxCopy.receptor.domicilioFiscalReceptor = infoEmployee?.RecepDomicilioFiscal ?? '';


        refreshModel(auxCopy);
    }

    renderHeaderFields = () => {
        const { model, action } = this.props;
        const { editMode } = this.state;
        const isDisabled = (action === 2 && !editMode);

        return (
            <div className="container">
                {this.state.enableSelectEmployee &&
                    <StandardSelectModal
                        id="selectEmployeeModal"
                        title="Empleados"
                        headers={itemsHeaders}
                        searchBar={this.state.searchItem}
                        data={this.state.NomEmployees}
                        selectAction={this.SelectEmployee}
                        actPos="start" />
                }

                {/* DATOS GENERALES */}
                <h5 className="mt-3 mb-2"> Datos del Comprobante</h5>
                <div className="row">
                    <div className="col-md-6">
                        {this.renderInput("Fecha", model.fecha, (e) => this.ChangeModelPropByKey("fecha", e), isDisabled, "date")}
                        {this.renderInput("Lugar de Expedición", model.lugarExpedicion, (e) => this.ChangeModelPropByKey("lugarExpedicion", e), isDisabled)}
                        {this.renderSelect("Método de Pago", model.metodoPago, model.metodoPagoOptions ?? [], (e) => this.ChangeModelPropByKey("metodoPago", e), isDisabled)}
                        {this.renderInput("Moneda", model.moneda, (e) => this.ChangeModelPropByKey("moneda", e), isDisabled)}
                    </div>
                    <div className="col-md-6">
                        {this.renderInput("Tipo de Comprobante", model.tipoDeComprobante, (e) => this.ChangeModelPropByKey("tipoDeComprobante", e), true)}
                        {this.renderInput("Versión", model.version, (e) => this.ChangeModelPropByKey("version", e), true)}
                        {this.renderInput("Exportación", model.exportacion, (e) => this.ChangeModelPropByKey("exportacion", e), isDisabled)}
                        {model.UUID && model.UUID !== '' &&
                            <div >
                                <div>
                                    <label className="btn float-left" onClick={() => this.DownloadDocNomina('PDF')}><i class="fa fa-file-text-o"></i> Descargar PDF Nomina </label>
                                    <label className="btn float-left" onClick={() => this.DownloadDocNomina('XML')}><i class="fa fa-file-text"></i> Descargar XML Nomina</label>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                {/* RECEPTOR */}
                <h5 className="mt-4 mb-2">Receptor</h5>
                <div className="row">
                    <div className="col-md-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">Nombre</span>
                            </div>
                            <input type='text' className="form-control" value={model.receptor?.nombre || ""} onChange={(event) => this.ChangeModelPropSubLevelByKey("receptor", "nombre", event.target.value)} disabled={isDisabled} />
                            {action === 1 && (
                                <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={this.OpenNomEmployeeList}>
                                    <i className="fas fa-user fa-lg" />
                                </button>
                            )}
                        </div>
                        {this.renderInput("RFC", model.receptor?.rfc, (e) => this.ChangeModelPropSubLevelByKey("receptor", "rfc", e.target.value), isDisabled)}
                        {this.renderInput("Uso CFDI", model.receptor?.usoCFDI, (e) => this.ChangeModelPropSubLevelByKey("receptor", "usoCFDI", e.target.value), isDisabled)}
                    </div>
                    <div className="col-md-6">
                        {this.renderInput("Régimen Fiscal", model.receptor?.regimenFiscalReceptor, (e) => this.ChangeModelPropSubLevelByKey("receptor", "regimenFiscalReceptor", e.target.value), isDisabled)}
                        {this.renderInput("Domicilio Fiscal", model.receptor?.domicilioFiscalReceptor, (e) => this.ChangeModelPropSubLevelByKey("receptor", "domicilioFiscalReceptor", e.target.value), isDisabled)}
                    </div>
                </div>

            </div>
        );
    };


    renderNominaBody = () => {
        const { model, action, countries } = this.props;
        const { editMode, parteTransporte, states, municipios, localidades, colonias, isSearchCodigoPostal } = this.state;
        // console.log('con<######### model ', model)
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-Nomina-Conceptos"
                            data-toggle="tab"
                            href="#Section-Nomina-Conceptos">
                            Conceptos
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-Nomina-Complemento"
                            data-toggle="tab"
                            href="#Section-Nomina-Complemento"
                        >
                            Complemento
                        </a>

                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-Nomina-PercepDeducc"
                            data-toggle="tab"
                            href="#Section-Nomina-PercepDeducc"
                        >
                            Percepciones y Deducciones
                        </a>

                    </div>
                </nav>
                <div class="tab-content" style={{ textAlign: 'left' }}>


                    {/* APARTADO CONCEPTOS */}
                    <div className="container tab-pane active" id="Section-Nomina-Conceptos" aria-labelledby="nav-Nomina-Conceptos">
                        <div style={{ marginTop: 30 }}>
                            <div class="w-100 table-scroll tab-pane " style={{ textAlign: 'left' }}>
                                <table id="dataTableDocuments" className="display" style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                    <thead className="table-header-yellow">
                                        <tr>

                                            <td class="sticky-columns">Cantidad</td>
                                            <td class="sticky-columns">Unidad</td>
                                            <td style={{ textAlign: 'center' }}>Cod. Prod. SAT (Search)</td>
                                            <td style={{ textAlign: 'center' }}>Concepto</td>
                                            <td style={{ textAlign: 'center' }}>Precio Unitario</td>
                                            <td style={{ textAlign: 'center' }}>Descuento</td>
                                            <td style={{ textAlign: 'center' }}>Objeto de impuesto</td>

                                            <td class="sticky-columns"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {model.conceptos && model.conceptos.length > 0 && model.conceptos.map((element, indexLine) => {
                                            return (
                                                <tr>
                                                    {/* CANTIDAD */}
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, width: "13vh", textAlign: "center" }}
                                                            id={'cantidad' + indexLine}
                                                            value={element?.cantidad ?? ''}
                                                            min={0}
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            onChange={event => this.ChangeConceptProp(indexLine, 'cantidad', event)}
                                                        />
                                                    </td>
                                                    {/* UNIDAD */}
                                                    <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            onChange={event => this.ChangeConceptProp(indexLine, 'claveUnidad', event)}
                                                            value={element.claveUnidad ?? ""}
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                        >

                                                            {this.state.UnidadConcepts.length > 0 &&
                                                                this.state.UnidadConcepts.map(((unityConcept) => {
                                                                    return (
                                                                        <option value={`${unityConcept?.Clave ?? ''},${unityConcept?.Nombre},${indexLine}`}>{unityConcept?.Nombre ?? ''}</option>
                                                                    );
                                                                }))}
                                                        </select>
                                                    </td>
                                                    {/* CODIGO PRODUCTO SERVICIO */}
                                                    <td style={{ textAlign: 'center' }}>
                                                        <div className='input-group'>
                                                            <input
                                                                type="text"
                                                                disabled={(action === 2) && !editMode ? true : false}
                                                                placeholder="Código Producto SAT"
                                                                className=" form-control validarCant cantBlur btn-outline text-center"
                                                                style={{ backgroundColor: element?.whsSelected ? 'rgb(248,242,209)' : 'transparent', color: '#000', paddingTop: 1, paddingBottom: 2, }}
                                                                value={element?.claveProdServ ?? ''}
                                                                onChange={event => this.ChangeConceptProp(indexLine, 'claveProdServ', event)}
                                                            />
                                                            {/* <div className="input-group-append" >
                                                            <button
                                                                type="button"
                                                                disabled={(action === 2) && !editMode ? true : false}
                                                                style={{ backgroundColor: 'transparent', color: '#EABF28', paddingTop: 2, paddingBottom: 2, border: "1px solid #ced4da" }}
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => this.OpenClaveProdSAT(indexLine, -1)}
                                                            >
                                                                <i className="fa fa-list" aria-hidden="true" />
                                                            </button>
                                                        </div> */}

                                                        </div>
                                                    </td>
                                                    {/* DESCRIPTION */}
                                                    <td>
                                                        <input
                                                            type="text"
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            className="form-control btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', height: 'auto', width: '30vh' }}
                                                            onChange={event => this.ChangeConceptProp(indexLine, 'descripcion', event)}
                                                            value={element?.descripcion ?? ''}
                                                        />
                                                    </td>
                                                    {/* PRECIO UNITARIO */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, width: 'auto', textAlign: "center", }}
                                                            id={'cantidad' + indexLine}
                                                            value={element?.valorUnitario ?? 0.0}
                                                            onChange={event => this.ChangeConceptProp(indexLine, 'valorUnitario', event)}
                                                        />
                                                    </td>
                                                    {/* DESCUENTO */}
                                                    <td>
                                                        <input
                                                            type="number"
                                                            disabled={(action === 2) && !editMode ? true : false}
                                                            className=" form-control validarCant cantBlur btn-outline-secondary"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, width: 'auto', textAlign: "center", }}
                                                            id={'cantidad' + indexLine}
                                                            value={element?.descuento ?? 0.0}
                                                            onChange={event => this.ChangeConceptProp(indexLine, 'descuento', event)}
                                                        />
                                                    </td>

                                                    {/* OBJETO DE IMPUESTO */}
                                                    <td>
                                                        <select className="form-control" style={{ width: "auto" }}
                                                            disabled={model?.TypeDoc === 'I' ? false : true}
                                                            onChange={event => this.ChangeConceptProp(indexLine, 'objetoImp', event)}
                                                            value={element.objetoImp ?? ""}
                                                        >
                                                            <option value='01'>No objeto de impuesto.</option>
                                                            <option value='02'>Sí objeto de impuesto.</option>
                                                            <option value='03'>Sí objeto del impuesto y no obligado al desglose.</option>
                                                            <option value='04'>Si objeto del impuesto y no causa impuesto</option>
                                                        </select>
                                                    </td>


                                                    {/* <td className="sticky-column" style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                    <button type="button"
                                                        style={{ backgroundColor: 'transparent', padding: 5, color: 'red', }}
                                                        className="btn"
                                                        onClick={() => this.RemoveConcept(indexLine)}
                                                    >
                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                    </button>
                                                </td> */}
                                                </tr>
                                            );
                                        })}
                                        <tr>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    {/* APARTADO COMPLEMENTO NOMINA */}
                    <div className="container tab-pane" id="Section-Nomina-Complemento" aria-labelledby="nav-Nomina-Complemento">
                        <div style={{ marginTop: 30 }}>
                            <div class="w-100 table-scroll tab-pane " style={{ textAlign: 'left' }}>
                                {/* DATOS GENERALES DE NÓMINA */}
                                <h5 className="mt-4 mb-2">Datos de Nómina</h5>
                                <div className="row">
                                    <div className="col-md-4">
                                        {this.renderInput("Versión", model.nomina?.version, (e) => this.ChangeModelPropSubLevelByKey("nomina", "version", e.target.value), true)}
                                        {this.renderInput("Tipo de Nómina", model.nomina?.tipoNomina, (e) => this.ChangeModelPropSubLevelByKey("nomina", "tipoNomina", e.target.value), true)}
                                        {this.renderInput("Fecha Pago", model.nomina?.fechaPago, (e) => this.ChangeModelPropSubLevelByKey("nomina", "fechaPago", e.target.value), false, "date")}
                                    </div>
                                    <div className="col-md-4">
                                        {this.renderInput("Fecha Inicial Pago", model.nomina?.fechaInicialPago, (e) => this.ChangeModelPropSubLevelByKey("nomina", "fechaInicialPago", e.target.value), false, "date")}
                                        {this.renderInput("Fecha Final Pago", model.nomina?.fechaFinalPago, (e) => this.ChangeModelPropSubLevelByKey("nomina", "fechaFinalPago", e.target.value), false, "date")}
                                        {this.renderInput("Número de Días Pagados", model.nomina?.numDiasPagados, (e) => this.ChangeModelPropSubLevelByKey("nomina", "numDiasPagados", e.target.value), true, "number")}
                                    </div>
                                    <div className="col-md-4">
                                        {this.renderInput("Total Percepciones", model.nomina?.totalPercepciones, null, true)}
                                        {this.renderInput("Total Deducciones", model.nomina?.totalDeducciones, null, true)}
                                        {this.renderInput("Total Otros Pagos", model.nomina?.totalOtrosPagos, null, true)}
                                    </div>
                                </div>

                                {/* EMISOR */}
                                <h5 className="mt-4 mb-2">Emisor</h5>
                                <div className="row">
                                    <div className="col-md-6">
                                        {this.renderInput("Registro Patronal", model.nomina?.emisor?.registroPatronal, (e) => this.ChangeModelPropSubLevelByKey("nomina.emisor", "registroPatronal", e.target.value), true)}
                                    </div>
                                </div>

                                {/* RECEPTOR */}
                                <h5 className="mt-4 mb-2">Receptor Nómina</h5>
                                <div className="row">
                                    <div className="col-md-4">
                                        {this.renderInput("CURP", model.nomina?.receptor?.curp, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "curp", e.target.value), false)}
                                        {this.renderInput("Cuenta Bancaria", model.nomina?.receptor?.cuentaBancaria, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "cuentaBancaria", e.target.value), false)}
                                        {this.renderInput("Número de Seguridad Social", model.nomina?.receptor?.numSeguridadSocial, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "numSeguridadSocial", e.target.value), false)}
                                    </div>
                                    <div className="col-md-4">
                                        {this.renderInput("Fecha Inicio Rel. Laboral", model.nomina?.receptor?.fechaInicioRelLaboral, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "fechaInicioRelLaboral", e.target.value), true, "date")}
                                        {this.renderInput("Antigüedad", model.nomina?.receptor?.antiguedad, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "antiguedad", e.target.value), true)}
                                        {this.renderInput("Tipo Contrato", model.nomina?.receptor?.tipoContrato, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "tipoContrato", e.target.value), false)}
                                        {this.renderInput("Sindicato", model.nomina?.receptor?.sindicato, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "sindicato", e.target.value), false)}
                                    </div>
                                    <div className="col-md-4">
                                        {this.renderInput("Tipo Jornada", model.nomina?.receptor?.tipoJornada, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "tipoJornada", e.target.value), false)}
                                        {this.renderInput("Tipo Régimen", model.nomina?.receptor?.tipoRegimen, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "tipoRegimen", e.target.value), false)}
                                        {this.renderInput("No. Empleado", model.nomina?.receptor?.numEmpleado, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "numEmpleado", e.target.value), false)}
                                        {this.renderInput("Departamento", model.nomina?.receptor?.departamento, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "departamento", e.target.value), false)}
                                        {this.renderInput("Puesto", model.nomina?.receptor?.puesto, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "puesto", e.target.value), false)}
                                        {this.renderInput("Riesgo Puesto", model.nomina?.receptor?.riesgoPuesto, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "riesgoPuesto", e.target.value), false)}
                                        {this.renderInput("Periodicidad de Pago", model.nomina?.receptor?.periodicidadPago, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "periodicidadPago", e.target.value), false)}
                                        {this.renderInput("Salario Base Cot. Apor.", model.nomina?.receptor?.salarioBaseCotApor, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "salarioBaseCotApor", e.target.value), false)}
                                        {this.renderInput("Salario Diario Integrado", model.nomina?.receptor?.salarioDiarioIntegrado, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "salarioDiarioIntegrado", e.target.value), false)}
                                        {this.renderInput("Clave Entidad Fed.", model.nomina?.receptor?.claveEntFed, (e) => this.ChangeModelPropSubLevelByKey("nomina.receptor", "claveEntFed", e.target.value), false)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* APARTADO NOMINA PERCEPCIONES Y DEDUCCIONES */}
                    <div className="container tab-pane" id="Section-Nomina-PercepDeducc" aria-labelledby="nav-Nomina-PercepDeducc">
                        <div>
                            <div class="w-100 table-scroll tab-pane " style={{ textAlign: 'left', marginTop: 30 }}>
                                <table className="display" style={{ width: '100%', marginBottom: 40 }}>
                                    <thead className="table-header-yellow">
                                        <tr>
                                            <th>Clave</th>
                                            <th>Tipo Percepción</th>
                                            <th>Concepto</th>
                                            <th>Importe Exento</th>
                                            <th>Importe Gravado</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {model?.nomina?.percepciones?.percepcion?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.clave}
                                                        onChange={e => this.ChangePercepcionProp(index, 'clave', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.tipoPercepcion}
                                                        onChange={e => this.ChangePercepcionProp(index, 'tipoPercepcion', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.concepto}
                                                        onChange={e => this.ChangePercepcionProp(index, 'concepto', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={item.importeExento}
                                                        onChange={e => this.ChangePercepcionProp(index, 'importeExento', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={item.importeGravado}
                                                        onChange={e => this.ChangePercepcionProp(index, 'importeGravado', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <button className="btn btn-danger" onClick={() => this.RemovePercepcion(index)}>Eliminar</button>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                <button className="btn btn-success" onClick={this.AddPercepcion}>Agregar Percepción</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div class="w-100 table-scroll tab-pane " style={{ textAlign: 'left', marginTop: 30 }}>
                                <table className="display" style={{ width: '100%', marginBottom: 40 }}>
                                    <thead className="table-header-yellow">
                                        <tr>
                                            <th>Clave</th>
                                            <th>Tipo Deducción</th>
                                            <th>Concepto</th>
                                            <th>Importe</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {model?.nomina?.deducciones?.deduccion?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.clave}
                                                        onChange={e => this.ChangeDeduccionProp(index, 'clave', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.tipoDeduccion}
                                                        onChange={e => this.ChangeDeduccionProp(index, 'tipoDeduccion', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.concepto}
                                                        onChange={e => this.ChangeDeduccionProp(index, 'concepto', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={item.importe}
                                                        onChange={e => this.ChangeDeduccionProp(index, 'importe', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <button className="btn btn-danger" onClick={() => this.RemoveDeduccion(index)}>Eliminar</button>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="5" className="text-center">
                                                <button className="btn btn-success" onClick={this.AddDeduccion}>Agregar Deducción</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="w-100 table-scroll tab-pane " style={{ textAlign: 'left', marginTop: 30 }}>
                                <table className="display" style={{ width: '100%', marginBottom: 40 }}>
                                    <thead className="table-header-yellow">
                                        <tr>
                                            <th>Tipo Otro Pago</th>
                                            <th>Clave</th>
                                            <th>Concepto</th>
                                            <th>Importe</th>
                                            <th>Subsidio Causado</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {model?.nomina?.otrosPagos?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.tipoOtroPago}
                                                        onChange={e => this.ChangeOtroPagoProp(index, 'tipoOtroPago', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.clave}
                                                        onChange={e => this.ChangeOtroPagoProp(index, 'clave', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        value={item.concepto}
                                                        onChange={e => this.ChangeOtroPagoProp(index, 'concepto', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={item.importe}
                                                        onChange={e => this.ChangeOtroPagoProp(index, 'importe', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={item.subsidioCausado}
                                                        onChange={e => this.ChangeOtroPagoProp(index, 'subsidioCausado', e)}
                                                    />
                                                </td>
                                                <td>
                                                    <button className="btn btn-danger" onClick={() => this.RemoveOtroPago(index)}>Eliminar</button>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                <button className="btn btn-success" onClick={this.AddOtroPago}>Agregar Otro Pago</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>


                </div>



            </div>
        )
    }


    renderNominaFooter = () => {
        const { model, action, countries } = this.props;
        const { editMode, parteTransporte, states, municipios, localidades, colonias, isSearchCodigoPostal } = this.state;
        // console.log('con<######### model ', model)
        return (
            <div style={{ marginTop: 30 }}>

                <h5 className="mt-4 mb-2">Totales</h5>
                <div className="row">
                    <div className="col-md-4">
                        {this.renderInput("Subtotal", model.subTotal, null, true)}
                    </div>
                    <div className="col-md-4">
                        {this.renderInput("Descuento", model.descuento, null, true)}
                    </div>
                    <div className="col-md-4">
                        {this.renderInput("Total", model.total, null, true)}
                    </div>
                </div>
            </div>
        )
    }
    //#endregion
}



export default NominaModal;